import * as Sentry from "@sentry/react";
import { useEffect } from "react";

interface Shop {
  id: string;
  myshopifyDomain: string;
}

export const SentryUserManager = ({ shop }: { shop: Shop }) => {
  useEffect(() => {
    Sentry.setUser({
      id: shop.id,
      username: shop.myshopifyDomain,
    });
  }, [shop.id, shop.myshopifyDomain]);

  return <></>;
};
